var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"flight-lazy-load"}},[_c('span',[_vm._v(" "+_vm._s(_vm.$t("flightLazyLoad_lblLazyLoad")))]),_c('lottie-animation',{attrs:{"speed":0.75,"path":"assets/animations/lazyLoad.json"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }